// tabbed-content.js – Fixed animation without inline styles

class TabbedContent {
  constructor(section) {
    this.section = section;
    this.tabs = section.querySelectorAll('.tabbed-content__tab');
    this.blocks = section.querySelectorAll('.tabbed-content__block');
    this.activeBlock = null;
    this.init();
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.handleTabClick.bind(this));
    });

    // Set first tab active on load
    if (this.tabs.length > 0 && !this.section.querySelector('.tabbed-content__tab--active')) {
      this.handleTabClick({ currentTarget: this.tabs[0] });
    }

    if (Shopify.designMode) {
      this.initEditorListeners();
    }
  }

  handleTabClick(event) {
    const clickedTab = event.currentTarget;
    const targetId = clickedTab.getAttribute('data-tab-target');
    const targetBlock = this.section.querySelector(targetId);

    if (!targetBlock || this.activeBlock === targetBlock) return;

    // Remove active from tabs
    this.tabs.forEach(tab => tab.classList.remove('tabbed-content__tab--active'));
    clickedTab.classList.add('tabbed-content__tab--active');

    // Handle block transition
    if (this.activeBlock) {
      this.activeBlock.classList.remove('tabbed-content__block--active');
      // Force exit animation
      this.activeBlock.addEventListener('transitionend', () => {
        if (this.activeBlock) this.activeBlock.classList.remove('tabbed-content__block--transitioning');
      }, { once: true });
      this.activeBlock.classList.add('tabbed-content__block--transitioning');
    }

    // Activate new block
    targetBlock.classList.add('tabbed-content__block--transitioning', 'tabbed-content__block--active');
    // Trigger reflow for enter animation
    void targetBlock.offsetWidth;
    targetBlock.classList.remove('tabbed-content__block--transitioning');

    this.activeBlock = targetBlock;
  }

  initEditorListeners() {
    this.section.addEventListener('shopify:section:load', () => this.init());

    this.section.addEventListener('shopify:block:select', (event) => {
      const blockId = event.detail.blockId;
      const targetTab = this.section.querySelector(`[data-tab-target="#tab-content-${blockId}"]`);
      if (targetTab) this.handleTabClick({ currentTarget: targetTab });
    });

    this.section.addEventListener('shopify:block:deselect', () => {
      if (this.tabs[0]) this.handleTabClick({ currentTarget: this.tabs[0] });
    });
  }
}

// Init
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tabbed-content').forEach(section => {
    new TabbedContent(section);
  });
});

document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('.tabbed-content').forEach(section => {
    new TabbedContent(section);
  });
});